<template>
    <div id="Mente">メンテナンス</div>
</template>

<script>
import contentView from '@/components/ContentView.vue'
import subMenu from '@/components/SubMenu.vue'
import {API_URL} from '@/services/config'
import {CONTENTS_SRV} from '@/services/config'
export default {
  name: 'Mente',
  components: {
   // HelloWorld
   contentView,
   subMenu
  },
  data(){
    return{
    loading: true,
    }
  },
  computed:{

  },
  mounted: function(){
      alert("a")
  },
  methods:{
  }
}



</script>